export default {
  metadataSelfTests: null,
  zeroRegistrySelfTests: null,
  metadataPersonalTests: null,
  metadataBHPersonalTests: null,
  variantsPersonalReport: null,
  metadataTest360: null,
  metadataBySpec: null,
  historyPulseTest360: null,
  userTest360: null,
  commentsTest360: null,
  approversTest360: null,
  descriptionTest360: null,
  questions: null,
  openQuestions: [],
  bhPersonalBlock: null,
  bhPersonalTest: null,
  bhPersonalQuestion: null,
  bhPersonalTestSession: {},
  urlPersonalTest: null,
  linkPersonalReport: null,
  userSurveys: {},
  userTests: {},
  userFeedbacks: {},
  isSubmitting: false,
  isSavingResults: false,
  isLoading: false,
  isLoadingDescriptionTest360: false,
  errors: null,
  validationErrors: null,
};
